import React from 'react';
import { Button } from '@trucktrax/trucktrax-common';
import {
  NO_ACTIVE_REGIONS_HEADER,
  NO_ACTIVE_REGIONS_LOGOUT_BTN_TEXT,
  NO_ACTIVE_REGIONS_NOTIFICATION,
} from '../../constants/appConstants';
import bgNotFoundJpg from '../../assets/img/bgNotfound.jpg';
import styles from './NoActiveRegions.module.css';

export interface NoActiveRegionsProps {
  onLogOut: () => void;
}

export function NoActiveRegions({ onLogOut }: NoActiveRegionsProps) {
  return (
    <div
      className={styles.overlay}
      style={{ backgroundImage: `url(${bgNotFoundJpg})` }}
      data-test="no-active-regions"
    >
      <div className={styles.content}>
        <h1 className={styles.header}>{NO_ACTIVE_REGIONS_HEADER}</h1>
        <p className={styles.text}>{NO_ACTIVE_REGIONS_NOTIFICATION}</p>
        <Button
          onClick={onLogOut}
          buttonClassName="tt-btn tt-btn--submit"
          name={NO_ACTIVE_REGIONS_LOGOUT_BTN_TEXT}
          dataTest="no-active-regions-logout-btn"
        />
      </div>
    </div>
  );
}

export default NoActiveRegions;
